module.exports = __webpack_public_path__ + "img/Icon-survey-locked-disabled.d0f6e024.svg";